import { useNavigate } from 'react-router';
import { SidebarProps } from './Types';
import { useAppSelector } from '../pgStore';
import UnauthenticatedUser from './User/UnauthenticatedUser';
import AuthenticatedUser from './User/AuthenticatedUser';
import { Button, Divider, Image, makeStyles } from '@fluentui/react-components';
import { MoreHorizontal32Filled } from '@fluentui/react-icons';
import NavbarLinks, { NavigationLink } from './NavbarLinks';

import './layoutStyles.scss';
import useRouteMatch from '../Hooks/useRouteMatch';

const useStyles = makeStyles({
	loginForm: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		width: '100%',
		margin: 'auto',
		padding: '5px'
	}
});

const SideBar = (props: SidebarProps) => {
	const styles = useStyles();
	const currentUser = useAppSelector((state) => state.userSlice);
	const navigator = useNavigate();
	const { isCurrentRoute } = useRouteMatch();

	function navItemClick(_event: unknown, item: NavigationLink) {
		void navigator(item.target);
		props.toggle(false);
	}

	return (
		<div
			id='application-navbar'
			className={props.isOpen ? '' : `unfocused`}
		>
			<div id='application-menu'>
				<div
					style={{
						backgroundColor: '#031024',
						borderBottom: '1px solid #07E3E3'
					}}
				>
					<img
						className={'logo'}
						src='/Peer-Gaming-Logo-256.png'
						alt=''
					/>
				</div>

				<div id='application-navbar-links'>
					{NavbarLinks.map((item, index) => (
						<div
							key={`nav-item-${String(index)}`}
							className={`application-navbar-item ${
								isCurrentRoute(item.target) ? 'active' : ''
							}`}
							onClick={(event) => {
								navItemClick(event, item);
							}}
						>
							<div>{item.icon}</div>

							<span className='pixel-font'>{item.display}</span>
						</div>
					))}
				</div>

				<div className='application-sidebar-footer'>
					<p className='copyright'>&copy; Sam Travarca</p>
					<Divider />

					<div className={styles.loginForm}>
						{!currentUser.authenticated && <UnauthenticatedUser />}

						{currentUser.authenticated && <AuthenticatedUser />}
					</div>
				</div>
			</div>

			<div id='application-mobile-navbar'>
				<Image
					src='Peer-Gaming-Logo-Minimized-Mobile.png'
					onClick={() => navigator('/')}
				/>
				<span className='mobile-nav-title'>Peer Gaming</span>
				<Button
					appearance='subtle'
					icon={<MoreHorizontal32Filled />}
					onClick={() => {
						props.toggle(true);
					}}
				></Button>
			</div>
		</div>
	);
};

export default SideBar;
